import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { AppStore, BaseRepo, Bucket, BucketsStore } from '@recruitee/legacy-app-store';
import type { CountryWithCurrency } from '@recruitee/payments-types';

@Injectable({ providedIn: 'root' })
export class PaymentsRepo extends BaseRepo {
  constructor(
    protected store: BucketsStore,
    protected httpApi: HttpApiService,
    protected appStore: AppStore,
  ) {
    super(store, httpApi, appStore);
  }

  // Storing data in bucket doesn't really work here, as we always expect
  // the most recent date time
  public loadDateTime(): Observable<string> {
    return this.httpApi.get('/payments/date_time').pipe(map(d => d.dateTime));
  }

  public getCountriesWithCurrencies(): Bucket<CountryWithCurrency[]> {
    return this.store.getBucket('payments.countries_with_currencies');
  }

  public loadCountriesWithCurrencies(): Bucket<CountryWithCurrency[]> {
    const bucket = this.getCountriesWithCurrencies();

    this.httpApi
      .get('/payments/countries')
      .pipe(
        map(d => d.result),
        this.attachRequestToBucket(bucket),
      )
      .subscribe();

    return bucket;
  }
}
